import React from "react";
import shop from "shop/shop";
import { Button, Table } from "semantic-ui-react";
import Collapsible                                                                    from 'react-collapsible';

export function ProductDownloads( { product } ) {
  const [resources, setResources] = React.useState( false )
  const [loading, setLoading] = React.useState( false )
  React.useEffect( () => {
    async function load() {
      setLoading( true )
      let res = await shop.fetch( `/shop/rest/data/v1/article/resources/${product.map_id}` )
      setResources( res )
      setLoading( false )
    }
    
    load()
  }, [product] )
  
  console.log("resources",resources)
  return <div>
    {loading && <br />}
    {!loading && resources && resources.length > 0 && <div>
      <Collapsible tabIndex={0} trigger={translate("Datenblätter")}>
        <div className="pt3 pl3 pr3 pt4-ns">
          <table>
            <colgroup>
              <col style={{ width: "75%" }} />
              <col style={{ width: "25%" }} />
            </colgroup>
            <tbody>
              {resources.map((filePackage, index) => (
                <tr className={index !== resources.length - 1 ? "bb b--black-20" : ""} key={filePackage.content}>
                  <td className="pa3 fw7 f4 tl">

                    <b>{filePackage.content.endsWith("Sicherheitsdatenblatt.pdf") ? translate("Sicherheitsdatenblatt") :
                      filePackage.content.endsWith("TechnischesDatenblatt.pdf") ? translate("Technisches Datenblatt") :
                        filePackage.content.endsWith("Montageanleitung.pdf") ? translate("Montageanleitung") :
                        filePackage.content.endsWith("Produktbeschreibung DE.pdf") ? translate("Produktbeschreibung DE") :
                        filePackage.content.endsWith("Product description EN.pdf") ? translate("Produktbeschreibung EN") :
                        filePackage.content.endsWith("Datenblatt.pdf") ? translate("Datenblatt") :
                        filePackage.content.endsWith("Sicherheitsdatenbl..pdf") ? translate("Sicherheitsdatenblatt") :
                        filePackage.content.endsWith("Etikett.pdf") ? translate("Etikett") :
                          filePackage.content.endsWith("Zertifikate.pdf") ? translate("Zertifikate") : filePackage.content.slice(0, -4)}</b>{console.log("filePackage",filePackage)}
                  </td>
                  <td className="fw6 tr"><div className="tr">
                    <Button style={{borderRadius: "35px"}} primary size={"tiny"} as={"a"} target={"_blank"} download={filePackage.content}
                      href={`${shop.config.API}data/v1/article/resources/${product.map_id}/${encodeURI(filePackage.map_id)}`}>{translate("Datei herunterladen")}</Button></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Collapsible>
    </div>}
  </div>
}


// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/ProductDownloads.js